<template>
  <button
    type="button"
    class="wg-floating-ball"
    :title="label"
    :aria-label="label"
    @click="$emit('click')"
  >
    <span class="wg-floating-ball-text">{{ shortLabel }}</span>
  </button>
</template>

<script>
export default {
  name: 'WorkGuidanceFloatingBall',
  props: {
    label: { type: String, default: '工作指引' }
  },
  emits: ['click'],
  computed: {
    shortLabel() {
      const text = (this.label || '工作指引').trim()
      if (text.length <= 4) return text
      return text.slice(0, 4)
    }
  }
}
</script>

<style scoped>
.wg-floating-ball {
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 999;
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #fff;
  box-shadow: 0 6px 20px rgba(30, 60, 114, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.wg-floating-ball:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(30, 60, 114, 0.55);
}

.wg-floating-ball-text {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  word-break: break-all;
}

@media (max-width: 768px) {
  .wg-floating-ball {
    left: 16px;
    bottom: 16px;
    width: 56px;
    height: 56px;
  }

  .wg-floating-ball-text {
    font-size: 12px;
  }
}
</style>
